export const SET_PRODUCTION = '@portal/SET_PRODUCTION';

export function setProduction(data) {
  return {
    type: SET_PRODUCTION,
    payload: { data },
  };
}
